import { Component } from '@angular/core';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'app-maintenance',
  templateUrl: '../templates/template1/views/app-maintenance.component.html',
  styleUrls: ['../templates/template1/themes/default/less/app-maintenance.component.less'
  ]
})
export class AppMaintenanceComponent {

}
